import { useRef } from "react";
import "./RemovablePill.css";
export default function RemovablePill({ pill, direction = "rtl", onRemove, onClick }) {
    const handleClick = (e) => {
        onRemove?.(pill);
    }
    return (
        <label className="rem-pill" style={{ direction: direction }}>
            <span onClick={onClick}>{pill.text}</span>
            <span className="rem-pill-x" aria-hidden="true" onClick={handleClick}>×</span>
        </label>
    )
}